import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Resets scroll position to top on navigation for public pages.
// Dashboard routes are intentionally excluded here.
// Hash targets (e.g. /Plans#plans) scroll to that element instead of the top.
function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (pathname.toLowerCase().startsWith('/dashboard')) {
      return;
    }
    if (hash) {
      const id = decodeURIComponent(hash.slice(1));
      let timeoutId;
      const tryScroll = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return true;
        }
        return false;
      };
      const frame = requestAnimationFrame(() => {
        if (!tryScroll()) {
          timeoutId = setTimeout(tryScroll, 100);
        }
      });
      return () => {
        cancelAnimationFrame(frame);
        if (timeoutId) clearTimeout(timeoutId);
      };
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}

export default ScrollToTop;
